<template>
    <app-layout>
      <template #header>
        <div class="max-w-5xl mx-auto">
          <div class="px-4 py-4 bg-accent-green text-left mb-4 sm:flex items-center">
            <h2 class="text-xl sm:text-2xl">
              Bestellung gilt für: <br>
              <span class="text-lg sm:text-xl font-serif">KW{{ $page.props.weekOfYear }} / {{ $page.props.formattedOrderDate }}</span>
            </h2>
            <div class="ml-auto mt-4 sm:mt-0 sm:pl-4">
              <Link :href="route('history')" class="link-button-lg">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                zum Bestellkalender
              </Link>
            </div>
          </div>
        </div>
        <p v-if="!$page.props.order || !$page.props.order.submitted" class="mb-6 text-accent-brown text-sm flex justify-center text-left">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-1 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
          </svg>
          <span>Bestellen Sie bis zum <b>{{ $page.props.limitDay }}</b> um <b>{{$page.props.startOfTodaysOrderCycle}} Uhr</b>, damit Ihre Lieferung pünktlich eintrifft.</span>
        </p>
        <p
          v-else-if="$page.props.order && $page.props.order.submitted"
          class="text-base p-6 bg-yellow-200 text-left flex">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 relative top-1 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
          </svg>
          <span>
            <b>Die Bestellung wurde vorgemerkt.</b> <br>
            Sie können diese noch bis zum  <b>{{ $page.props.limitDay }}</b> um <b>{{$page.props.startOfTodaysOrderCycle}}:00 Uhr</b> bearbeiten.
          </span>
        </p>
        <p
          v-if="$page.props.afterDeletion"
          class="text-base p-6 bg-yellow-200 text-left flex">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 relative top-1 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
          </svg>
          <span>
            <b>Die Bestellung wurde erfolgreich gelöscht bzw. storniert.</b>
          </span>
        </p>
        <Filter />
        <h2 class="text-4xl mt-6 md:mt-8">Sortiment</h2>
        <ShopIndex
          :order-id="$page.props.order ? $page.props.order.id : null"
          :order-date="$page.props.orderDate"
          :categories="$page.props.categories"
          :tags="$page.props.tags" />
      </template>
    </app-layout>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import AppLayout from '@/Layouts/AppLayout'
import ShopIndex from '@/Components/Product/ShopIndex'
import Filter from '@/Components/Filter/Filter'

export default {
  components: {
    AppLayout,
    ShopIndex,
    Link,
    Filter
  },
}
</script>
